import { render, staticRenderFns } from "./PlanningExportMailPopup.vue?vue&type=template&id=53f16736&"
import script from "./PlanningExportMailPopup.vue?vue&type=script&lang=js&"
export * from "./PlanningExportMailPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports